import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X, ArrowRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Boiler Hire',
    path: '/boiler-hire'
  }, {
    name: 'Heater Hire',
    path: '/heater-hire'
  }, {
    name: 'Chiller Hire',
    path: '/chiller-hire'
  }, {
    name: 'Cooling Hire',
    path: '/cooling-hire'
  }, {
    name: 'Ancillaries',
    path: '/ancillaries'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <header className={`w-full flex flex-col z-50 sticky top-0 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-white py-4'}`} data-id="element-81">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-82">
        {/* Top Section: Logo & CTA */}
        <div className="flex justify-between items-center mb-4" data-id="element-83">
          <Link to="/" className="flex items-center text-2xl md:text-3xl font-heading font-extrabold tracking-tight" data-id="element-84">
            <span className="text-brand-navy" data-id="element-85">RAPID</span>
            <span className="text-brand-amber ml-1" data-id="element-86">ENERGY</span>
          </Link>

          <div className="hidden md:flex items-center space-x-6" data-id="element-87">
            <a href="tel:08004647025" className="flex items-center text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-88">
              <Phone className="w-5 h-5 mr-2 text-brand-amber" data-id="element-89" />
              0800 464 7025
            </a>
            <Link to="/contact" className="bg-brand-amber text-white px-6 py-2.5 rounded font-bold hover:bg-brand-navy transition-colors flex items-center" data-id="element-90">
              Get a Quote <ArrowRight className="w-4 h-4 ml-2" data-id="element-91" />
            </Link>
          </div>

          <button className="md:hidden p-2 text-brand-navy" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-92">
            {isMobileMenuOpen ? <X className="w-7 h-7" data-id="element-93" /> : <Menu className="w-7 h-7" data-id="element-94" />}
          </button>
        </div>

        {/* Bottom Section: Navigation */}
        <nav className="hidden md:flex items-center space-x-6 border-t border-gray-100 pt-4" data-id="element-95">
          {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors relative group ${isActive(link.path) ? 'text-brand-amber' : 'text-brand-slate hover:text-brand-navy'}`} data-id="element-96">
              {link.name}
              <span className={`absolute -bottom-4 left-0 w-full h-0.5 bg-brand-amber transform origin-left transition-transform duration-300 ${isActive(link.path) ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}`} data-id="element-97"></span>
            </Link>)}
        </nav>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-98">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-brand-navy text-white absolute top-full left-0 w-full shadow-xl overflow-hidden" data-id="element-99">
            <div className="px-4 py-6 space-y-2" data-id="element-100">
              {navLinks.map(link => <Link key={link.name} to={link.path} className={`block px-4 py-3 rounded-md text-base font-medium transition-colors ${isActive(link.path) ? 'bg-brand-amber/10 text-brand-amber' : 'hover:bg-white/5'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-101">
                  {link.name}
                </Link>)}
              <div className="mt-6 pt-6 border-t border-white/10 flex flex-col space-y-4 px-4" data-id="element-102">
                <a href="tel:08004647025" className="flex items-center text-xl font-bold text-white" data-id="element-103">
                  <Phone className="w-6 h-6 mr-3 text-brand-amber" data-id="element-104" />
                  0800 464 7025
                </a>
                <Link to="/contact" className="bg-brand-amber text-white text-center py-3 rounded font-bold" onClick={() => setIsMobileMenuOpen(false)} data-id="element-105">
                  Get a Quote
                </Link>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}